import React from 'react';
import './HoneycombLogo.css';

const HoneycombLogo = ({ size = 40 }) => {
    // Hexagon helper function
    const createHexagon = (cx, cy, radius) => {
        const points = [];
        for (let i = 0; i < 6; i++) {
            const angle = (Math.PI / 3) * i;
            const x = cx + radius * Math.cos(angle);
            const y = cy + radius * Math.sin(angle);
            points.push(`${x},${y}`);
        }
        return points.join(' ');
    };

    const hexRadius = 10;
    const hexWidth = hexRadius * 2 * Math.sin(Math.PI / 3);

    // Create 7 hexagon cluster - proper spacing
    const honeycombs = [
        // Center hexagon
        { x: 50, y: 50 },
        // Surrounding hexagons (proper spacing for no overlap)
        { x: 50, y: 50 - hexWidth },
        { x: 50 + hexRadius * 1.5, y: 50 - hexWidth / 2 },
        { x: 50 + hexRadius * 1.5, y: 50 + hexWidth / 2 },
        { x: 50, y: 50 + hexWidth },
        { x: 50 - hexRadius * 1.5, y: 50 + hexWidth / 2 },
        { x: 50 - hexRadius * 1.5, y: 50 - hexWidth / 2 },
    ];

    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 100 100"
            className="honeycomb-logo"
        >
            {/* Honeycomb cells - outline only */}
            <g className="honeycomb-cells">
                {honeycombs.map((hex, i) => (
                    <polygon
                        key={i}
                        points={createHexagon(hex.x, hex.y, hexRadius)}
                        fill="none"
                        stroke="#FFD700"
                        strokeWidth="2"
                        strokeLinejoin="round"
                        className={`hex hex-${i}`}
                    />
                ))}
            </g>

            {/* Worker Bees */}
            <g className="worker-bees">
                {/* Bee 1 - Top right */}
                <g className="bee bee-1" transform="translate(75, 22) rotate(-20)">
                    <ellipse cx="0" cy="0" rx="3.5" ry="2.5" fill="#000000" />
                    <ellipse cx="0.5" cy="0" rx="2.5" ry="1.8" fill="#FFD700" />
                    <line x1="-0.8" y1="-1.5" x2="-0.8" y2="1.5" stroke="#000000" strokeWidth="0.6" />
                    <line x1="1" y1="-1.5" x2="1" y2="1.5" stroke="#000000" strokeWidth="0.6" />
                    <ellipse cx="-2" cy="-1" rx="2.5" ry="1.2" fill="#ffffff" opacity="0.7" />
                    <ellipse cx="-2" cy="1" rx="2.5" ry="1.2" fill="#ffffff" opacity="0.6" />
                    <path d="M -2.8 -1.5 L -4 -2.5" stroke="#000000" strokeWidth="0.4" />
                    <path d="M -2.8 -1.5 L -3.5 -3" stroke="#000000" strokeWidth="0.4" />
                </g>

                {/* Bee 2 - Bottom left */}
                <g className="bee bee-2" transform="translate(20, 75) rotate(35)">
                    <ellipse cx="0" cy="0" rx="4" ry="2.8" fill="#000000" />
                    <ellipse cx="0.5" cy="0" rx="3" ry="2.2" fill="#FFD700" />
                    <line x1="-1" y1="-2" x2="-1" y2="2" stroke="#000000" strokeWidth="0.6" />
                    <line x1="1.2" y1="-2" x2="1.2" y2="2" stroke="#000000" strokeWidth="0.6" />
                    <ellipse cx="-2.5" cy="-1.2" rx="3" ry="1.5" fill="#ffffff" opacity="0.7" />
                    <ellipse cx="-2.5" cy="1.2" rx="3" ry="1.5" fill="#ffffff" opacity="0.6" />
                    <path d="M -3.5 -2 L -5 -3" stroke="#000000" strokeWidth="0.4" />
                    <path d="M -3.5 -2 L -4.5 -3.5" stroke="#000000" strokeWidth="0.4" />
                </g>

                {/* Bee 3 - Right side */}
                <g className="bee bee-3" transform="translate(80, 60) rotate(5)">
                    <ellipse cx="0" cy="0" rx="3.5" ry="2.5" fill="#000000" />
                    <ellipse cx="0.5" cy="0" rx="2.5" ry="1.8" fill="#FFD700" />
                    <line x1="-0.8" y1="-1.5" x2="-0.8" y2="1.5" stroke="#000000" strokeWidth="0.6" />
                    <line x1="1" y1="-1.5" x2="1" y2="1.5" stroke="#000000" strokeWidth="0.6" />
                    <ellipse cx="-2" cy="-1" rx="2.5" ry="1.2" fill="#ffffff" opacity="0.7" />
                    <ellipse cx="-2" cy="1" rx="2.5" ry="1.2" fill="#ffffff" opacity="0.6" />
                    <path d="M -2.8 -1.5 L -4 -2.5" stroke="#000000" strokeWidth="0.4" />
                    <path d="M -2.8 -1.5 L -3.5 -3" stroke="#000000" strokeWidth="0.4" />
                </g>
            </g>
        </svg>
    );
};

export default HoneycombLogo;
